<!-- Separate Bar Promo -->
<div *ngIf="infoView" class="separate-bar-promo" fxLayoutAlign="center start" [ngStyle]="{'background-color': getBackgroundColor()}">
    <h1 class="background-font" [@scrollAnimationBackgroundFont]="state">{{ infoView.background_text }}</h1>
    <div fxFlex="1280px" fxFlex.lt-lg="90%">
        <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="60px" fxLayoutGap.sm="30px">
            <div fxFlex="50%" fxFlexOrder.xs="2">
                <div class="img-product-offert" [@scrollAnimationImage]="state">
                    <img [src]="infoView.image_product" alt="Product Offert" />
                    <div *ngIf="infoView.is_show_circle_offert" class="circle-offert">
                        <h2>{{ infoView.circle_offert_title }}</h2>
                        <p><small>{{ infoView.circle_offert_text }}</small></p>
                    </div>
                </div>
            </div>
            <div fxFlex="50%" fxFlexOrder.xs="1">
                <div class="texts-center">
                    <h1 [@scrollAnimationTitle]="state">{{ infoView.title_box }}</h1>
                    <h3 [@scrollAnimationPrice]="state">{{ infoView.price_real }} <span>{{ infoView.price_without_discount }}</span></h3>
                    <button *ngIf="infoView.is_show_button_cart" mat-button [@scrollAnimationButtonOne]="state" (click)="onClickCart()"><span class="jam jam-shopping-cart"></span> SUMAR AL CARRITO</button>
                    <button *ngIf="infoView.is_show_button_extra" mat-stroked-button [@scrollAnimationButtonTwo]="state" (click)="onClickLink()">{{ infoView.button_extra_text }}</button>
                </div>
            </div>
        </div>
    </div>
</div>